<template>
  <TMainForm :script-id="scriptId" :interception="interception" :default-design="defaultDesign" ref="MainForm"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" :buttons="buttons" />
</template>

<script setup>
/**
 * TTMVacuumForm
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';
import { ref, computed } from 'vue';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: Boolean, default: null },
});
const MainForm = ref(null);

const buttons = computed(() => [
  {
    key: 'VACUUM_RUN',
    index: 15,
    name: 'Запуск',
    click: () => MainForm.value?.write('VACUUM_RUN', 1),
  },
  {
    key: 'VACUUM_STOP',
    index: 16,
    name: 'Стоп',
    click: () => MainForm.value?.write('VACUUM_STOP', 1),
  },
  {
    key: 'VACUUM_RESET',
    index: 11,
    name: 'Сброс аварии',
    click: () => MainForm.value?.write('VACUUM_RESET', 1),
  },
]);

const defaultDesign = FORM_DESIGNS.TTMVacuumForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMVacuumForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMVacuumForm;
</script>
